<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
  >
    <path
      d="M6.97074 4.81055C6.97074 4.81055 10.9707 7.75648 10.9707 8.81055C10.9707 9.86468 6.9707 12.8105 6.9707 12.8105"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>